import React, {Component} from 'react';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';

class Spinner extends Component {
    render() {
        const {className, infoText} = this.props;

        return (
            <div
                className={classNamesPrefixed({
                    'spinner': true,
                    [className]: className
                })}
            >
                <div
                    className={classNamesPrefixed({
                        'double-bounce1': true,
                        [className]: className
                    })}
                />
                <div
                    className={classNamesPrefixed({
                        'double-bounce2': true,
                        [className]: className
                    })}
                />
                {infoText && <div className={"info-text"}>{infoText}</div>}
            </div>
        );
    }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/core/admin/components/UI/Spinner.js